module.exports = __webpack_public_path__ + "img/mv-kanta.5f463e34.png";